<template>
  <el-dialog title="批量操作" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <!--选中数量-->
      <el-form-item label="选中数量" :label-width="formLabelWidth">
        <p class="red f20">{{ formData.ids.length || '暂无选中记录' }}</p>
      </el-form-item>

      <el-form-item label="年份" :label-width="formLabelWidth">
        <el-select v-model="formData.year" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option :label="v" :value="v" v-for="(v, i) in [2023,2024,2025,2026,2027,2028]" :key="i"></el-option>
        </el-select>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="选择专业" prop="major" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.major">
            <el-radio label="">不操作</el-radio>
            <el-radio :label="1">应用心理专硕</el-radio>
            <el-radio :label="2">心理学学硕</el-radio>
            <el-radio :label="3">心理健康教育专硕</el-radio>
          </el-radio-group>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="学习方式" prop="study_way" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.study_way">
            <el-radio label="">不操作</el-radio>
            <el-radio :label="1">全日制</el-radio>
            <el-radio :label="2">非全日制</el-radio>
          </el-radio-group>
      </el-form-item>

      <!--是否删除-->
      <el-form-item label="删除" prop="is_delete" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_delete">
          <el-radio label="">不操作</el-radio>
          <el-radio :label="1">删除</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading || ids.length==0">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SchoolParamsApi from '@/api/study/school_params.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        ids: [],
        status: '',
        is_delete: '',
      },
      /*验证规则*/
      formRules: {},
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['is_open', 'ids'],
  created() {
    this.dialogVisible = this.is_open;
    this.formData.ids = this.ids;
  },
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      if (params.ids.length<=0){
        self.$message({
          message: '暂无选中记录',
          type: 'warning'
        });
        return;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SchoolParamsApi.batch(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/schoolparams/part/Batch.vue